import ApiClient from "./apiClient";

const WorkRecordApi = {
  // 운동기록 리스트
  listByUser(userId, startDate = "", endDate = "", type = "") {
    return ApiClient.get(`/workrecord/list/${userId}`, {
      params: { startDate, endDate, type },
    });
  },

  // 운동기록 상세
  get(workRecordId) {
    return ApiClient.get(`/workrecord/view/${workRecordId}`);
  },

  // 운동기록 통계
  stats(userId, startDate = "", endDate = "", type = "", battleType = "") {
    return ApiClient.get(`/workrecord/stats/${userId}`, {
      params: { startDate, endDate, type, battleType },
    });
  },

  // 운동기록 기간 목록(주/월/연)
  periods(userId) {
    return ApiClient.get(`/workrecord/periods/${userId}`);
  },

};

export default WorkRecordApi;
